import { faBus, faKey, faPlug, faSignalStream, faUserLock } from "@fortawesome/pro-solid-svg-icons"
import { Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { OverviewCard } from "./OverviewCard"

export const Overview = ({ overviewData }) => {
  const { t } = useTranslation()
  const cards = [
    {
      title: t("global.vehicle", "Vehicle"),
      icon: faBus,
      value: overviewData !== null ? overviewData.totalDevices : "-"
    },
    {
      title: t("global.vehicle_online", "Vehicle online"),
      icon: faSignalStream,
      value: overviewData !== null ? overviewData.devicesOnlineLast24h : "-"
    },
    {
      title: t("global.canbus", "Canbus"),
      icon: faPlug,
      value: overviewData !== null ? overviewData.devicesWithAnySentMasterCanMessage : "-"
    },
    {
      title: t("global.immobilizer_active", "Immobilizer active"),
      icon: faUserLock,
      value: overviewData !== null ? overviewData.devicesWithAnySentDriverCard : "-"
    },
    {
      title: t("global.alcohol_lock_active", "Alcohol lock active"),
      icon: faKey,
      value: overviewData !== null ? overviewData.devicesWithAnySentAlcoholAlarms : "-"
    }
  ]

  return (
    <Grid container spacing={2}>
      {cards.map((card) => {
        return <OverviewCard key={card.title} card={card} />
      })}
    </Grid>
  )
}
